<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant
            type="search"
            name="plantCd"
            v-model="searchParam.plantCd"
            @input="getList"
          />
        </div>
      </template>
    </c-search-box>
    <div>
      <c-tree-table
        ref="deptTable"
        title="LBL0003215"
        parentProperty="upDeptCd"
        customID="deptCd"
        :columns="grid.columns"
        :data="grid.data"
        :gridHeight="grid.height"
        :columnSetting="false"
        :isFullScreen="false"
        :usePaging="false"
        :expandAll="true"
        :selection="popupParam.type"
        rowKey="deptCd"
        @rowClick="rowClick"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline>
            <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
            <!-- <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" /> -->
          </q-btn-group>
        </template>
      </c-tree-table>
      <!-- <c-table
        ref="deptTable"
        title="부서 목록"
        :columns="grid.columns"
        :data="grid.data"
        :gridHeight="grid.height"
        :selection="popupParam.type"
        :isExcelDown="false"
        :isFullScreen="false"
        :columnSetting="false"
        rowKey="userId"
        @rowClick="rowClick"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
            <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </template>
      </c-table> -->
    </div>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "user-pop",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          type: "single",
          plantCd: "",
        };
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [
          // {
          //   name: 'plantName',
          //   field: 'plantName',
          //   label: 'LBLPLANT',
          //   align: 'center',
          //   sortable: true,
          // },
          {
            name: "deptName",
            field: "deptName",
            label: "LBLDEPT",
            align: "left",
            sortable: true,
          },
          {
            name: "deptCd",
            field: "deptCd",
            // 부서코드
            label: "LBL0003217",
            align: "center",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "sortOrder",
            field: "sortOrder",
            // 정렬순서
            label: "LBLSORTORDER",
            align: "center",
            style: "width:60px",
            sortable: false,
          },
        ],
        data: [],
        height: "600px",
      },
      searchParam: {
        plantCd: null,
        deptCd: null,
        useFlag: "Y",
      },
      editable: true,
      listUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    plantCd() {
      return this.searchParam.plantCd || this.popupParam.plantCd;
    },
  },
  watch: {
    contentHeight() {
      let height =
        this.contentHeight - this.$refs["searchbox"].$el.offsetHeight - 50;
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + "px";
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.dept.list.url;
      // code setting
      // list setting
      if (this.popupParam.plantCd)
        this.searchParam.plantCd = this.popupParam.plantCd;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    select() {
      let selectData = this.$refs["deptTable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "안내",
          message: "선택된 항목이 없습니다.",
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowClick(row) {
      if (this.popupParam.type === "single") {
        this.$emit("closePopup", [row]);
      }
    },
  },
};
</script>
